var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Share_1",
    "data-name": "Share 1",
    transform: "translate(-428 -103)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2950",
    "data-name": "Rectangle 2950",
    transform: "translate(428 103)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_34064",
    "data-name": "Path 34064",
    d: "M130,128.8l8.834,6.9L130,142.6v-3.589c-.47-.022-5.472-1.389-11.166,3.589,2.279-7.02,6.245-8.969,11.166-10.215Z",
    transform: "translate(309.169 -22.8)",
    fill: "#989898"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubShare);
export default __webpack_public_path__ + "static/media/subShare.8545962a77660393d63fa75cfba9be8c.svg";
export { ForwardRef as ReactComponent };